export default "__VITE_ASSET__DblAfBm9__"